import { MenuItem, Select } from "@mui/material";
import { Button } from "components/atoms/Button";
import { Delete } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import MUITheme from "components/MUITheme";
import { useFeatureFlagEnabled } from "posthog-js/react";

const FUELS = [
    { value: "electricity", label: "Electricity" },
    { value: "natural_gas", label: "Natural gas" },
    { value: "steam", label: "Steam" },
];

function FuelCostReductionEffectInput({
    inputs,
    setInputs,
}: {
    inputs: FuelCostReductionEffect[];
    setInputs: (inputs: FuelCostReductionEffect[]) => void;
}) {
    const featureEnabled = useFeatureFlagEnabled("fuel-cost-reduction-measure-effect");
    const addConsumptionReduction = () => {
        setInputs([
            ...inputs,
            {
                // Arbitrary ID is provided to object as it has not been saved to
                // a databse yet.
                id: 0,
                uid: crypto.randomUUID(),
                fuel: "",
                percentReduction: null,
                absoluteReduction: null,
            },
        ]);
    };
    const handleChange = (id: string, field: string, value: string | number | null) => {
        const newValues = inputs.map((inputObj) => (inputObj.uid === id ? { ...inputObj, [field]: value } : inputObj));
        setInputs(newValues);
    };
    const removeConsumptionReduction = (uid: string) => {
        setInputs(inputs.filter((input) => input.uid !== uid));
    };
    if (!featureEnabled) {
        return null;
    }
    return (
        <div>
            {inputs.map((inputObj) => (
                <div key={inputObj.uid} className="effect-container">
                    <div className="effect-header">
                        <Header size="medium">Fuel cost reduction</Header>
                        <Button onClick={() => removeConsumptionReduction(inputObj.uid)} icon={<Delete />} />
                    </div>
                    <Header size="small">Fuel</Header>
                    <MUITheme primaryColor="#EB03AD">
                        <Select
                            required
                            value={inputObj.fuel}
                            onChange={(e) => handleChange(inputObj.uid, "fuel", e.target.value || "")}
                            style={{
                                width: "100%",
                                height: "35px",
                                minWidth: 0,
                                backgroundColor: "white",
                            }}
                        >
                            {FUELS.map((unit) => (
                                <MenuItem key={unit.value} value={unit.value}>
                                    {unit.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </MUITheme>
                    <Header size="small">Percent reduction</Header>
                    <input
                        key="fuelConsumptionReductionPercentage"
                        required={false}
                        type="number"
                        value={inputObj.percentReduction || ""}
                        className="filter-input"
                        onWheel={(e) => e.currentTarget.blur()}
                        onChange={(e) => {
                            const value = e.target.value === null ? null : Number(e.target.value);
                            handleChange(inputObj.uid, "percentReduction", value);
                        }}
                        placeholder="Enter a percentage reduction"
                    />
                    {/*
                    <Header size="small">Absolute reduction</Header>
                    <input
                        key="fuelConsumptionReductionAbsolute"
                        required={false}
                        type="number"
                        value={inputObj.absoluteReduction || ""}
                        className="filter-input"
                        onWheel={(e) => e.currentTarget.blur()}
                        onChange={(e) => {
                            const value = e.target.value === null ? null : Number(e.target.value);
                            handleChange(inputObj.uid, "absoluteReduction", value);
                        }}
                        placeholder="Enter an absolute reduction"
                    />
                    */}
                </div>
            ))}
            <div className="filter-container">
                <Button type="primary" onClick={addConsumptionReduction}>
                    + Add fuel cost reduction
                </Button>
            </div>
        </div>
    );
}

export default FuelCostReductionEffectInput;
